import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import StatusMessages from '../../components/StatusMessages';
import BlankState from '../../components/BlankState';

import Utils from '../../utils/mci-utils';
import { signUp } from '../../actions/user';
import Cleave from 'cleave.js/react';
import simpleReactValidator from 'simple-react-validator';

class Register extends Component {
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      user: {
        first_name: '',
        last_name: '',
        username: '',
        password: '',
        email: '',
        postal_address: '',
        phone: '',
        tra_pin: '',
        national_id: ''
      },
      has_errors: false,
      registration_is_loading: false
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    const { user } = this.state;

    this.setState({
      user: {
        ...user,
        [name]: value
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { user } = this.state;
    if (this.validator.allValid()) {
      this.validator.hideMessages();
      if (
        user.first_name &&
        user.last_name &&
        user.email &&
        Utils.isEmailAddress(user.email) &&
        user.password &&
        Utils.isTRA(user.tra_pin)
      ) {
        // TODO: REMOVE SENDING OF PASSWORD 2 FROM THE API
        const userInfo = {
          user: {
            first_name: user.first_name,
            last_name: user.last_name,
            username: user.username,
            password: user.password,
            password2: user.password,
            insurer: null,
            email: user.email,
            phone: user.phone,
            is_active: 'True'
          },
          profile: {
            national_id: user.national_id,
            tra_pin: user.tra_pin
          },
          type: 'sailor'
        };
        this.props.signUp(userInfo);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    let users = this.props ? this.props.user : null;

    const { user, has_errors, registration_is_loading } = this.state;

    return (
      <div className="clearfix">
        <form name="regfrm" onSubmit={this.handleSubmit}>
          {users.errorRegisterUser && !registration_is_loading ? (
            <StatusMessages
              type="error"
              message={users.errorMessageRegisterUser}
            />
          ) : null}
          {users.registerationInfo ? (
            <StatusMessages
              type="success"
              message={users.registerationInfo.Info + ''}
            />
          ) : null}

          <BlankState
            data={false}
            customMessage="Registering user"
            isDataLoading={registration_is_loading}
          />
          <input
            name="first_name"
            id="first_name"
            className="form-control"
            label="First Name"
            placeholder="First Name"
            type="text"
            value={user.first_name}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'first_name',
            user.first_name,
            'required',
            'text-danger'
          )}
          <input
            name="last_name"
            id="last_name"
            label="Last Name"
            className="form-control"
            placeholder="Last Name"
            type="text"
            value={user.last_name}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'last_name',
            user.last_name,
            'required',
            'text-danger'
          )}
          <input
            name="email"
            id="email"
            className="form-control"
            label="Email Address"
            placeholder="Email Address"
            type="email"
            value={user.email}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'email',
            user.email,
            'required|email',
            'text-danger'
          )}
          <input
            name="phone"
            id="phone"
            label="Phone Number"
            placeholder="Phone Number"
            type="text"
            className="form-control"
            value={user.phone}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'phone',
            user.phone,
            'required|gt:8',
            'text-danger'
          )}
          <input
            name="postal_address"
            id="postal_address"
            label="Postal Address"
            className="form-control"
            placeholder="Postal Address"
            type="text"
            value={user.postal_address}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'postal_address',
            user.postal_address,
            'required',
            'text-danger'
          )}
          <Cleave
            options={{
              blocks: [3, 3, 4],
              delimiter: '-',
              numericOnly: true
            }}
            className="form-control"
            name="tra_pin"
            id="tra_pin"
            label="Tax Payer PIN"
            placeholder="Tax Payer PIN"
            type="text"
            value={user.tra_pin}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'tra_pin',
            user.tra_pin,
            'required',
            'text-danger'
          )}
          <Cleave
            options={{
              blocks: [3, 3, 4],
              delimiter: '-',
              numericOnly: true
            }}
            className="form-control"
            name="national_id"
            id="national_id"
            label="National ID"
            placeholder="National ID"
            type="text"
            value={user.national_id}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'national_id',
            user.national_id,
            'required',
            'text-danger'
          )}
          <p className="text-muted">You will use these details to log in</p>

          <input
            name="username"
            label="Username"
            className="form-control"
            placeholder="Username"
            type="text"
            value={user.username}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'username',
            user.username,
            'required',
            'text-danger'
          )}
          <input
            name="password"
            label="Password"
            className="form-control"
            placeholder="Password"
            type="password"
            value={user.password}
            onChange={this.handleChange}
          />
          {this.validator.message(
            'password',
            user.password,
            'required',
            'text-danger'
          )}
          <div className="form-group">
            <button
              type="submit"
              id="submit"
              className="btn btn-primary btn-lg"
            >
              Register
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  policy: state.policy
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ signUp }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);



// WEBPACK FOOTER //
// ./src/pages/auth/Register.js